<template>
	<div id="app">
		<header-backend v-if="navState == 'backend'"></header-backend>
		<header-frontend v-if="navState == 'frontend'"></header-frontend>

			<router-view :key="$route.fullPath"/>

		<footer-backend v-if="navState == 'backend'"></footer-backend>
		<footer-frontend v-if="navState == 'frontend'"></footer-frontend>

		<back-to-top></back-to-top>
	</div>
</template>

<script>
	//Templates
	import HeaderBackend from './components/backend/templates/Header.vue';
	import FooterBackend from './components/backend/templates/Footer.vue';

	import HeaderFrontend from './components/frontend/templates/Header.vue';
	import FooterFrontend from './components/frontend/templates/Footer.vue';

	import BackToTop from './components/BackToTop.vue';

	//Vuex maps
	import { mapState } from 'vuex'

	var favicon = require('./assets/img/logo.png');

	export default {
		components: {
			HeaderBackend, FooterBackend, HeaderFrontend, FooterFrontend, BackToTop
		},
		name: 'App',
		computed: {
			...mapState(['navState'])
		},
		metaInfo() {
            return {
				// if no subcomponents specify a metaInfo.title, this title will be used
				title: 'M&O Law Consult',
				// all titles will be injected into this template
				titleTemplate: '%s | M&O Law Consult',
				link: [{ rel: 'icon', href: favicon }],
				bodyAttrs: {
					class: (this.navState === 'frontend') ? 'bg-white pt-custom': '',
				}
			}
		},
		methods: {
			setUserData() {
				let authUser = JSON.parse(window.localStorage.getItem('authUser'));
				if (authUser !== null && undefined !== authUser) {
					let user = {
						firstname: authUser.firstname,
						lastname: authUser.lastname,
						adminid: authUser.adminid,
						email: authUser.email,
						profileImg: '',
						access_token: authUser.access_token
					};

					this.$store.commit('SET_USER_DATA', user);
				}
			},
			
		},
		created() {
			this.setUserData();
		}
	}
</script>

<style lang="scss">
	// @import './assets/css/theme.min.css';
	@import url('./assets/feather.min.css');
	@import url('./assets/themify-icons.css');
	@import url('./assets/css/font-awesome.min.css');
	@import url('./assets/fonts.css');
</style>



// WEBPACK FOOTER //
// src/App.vue